var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLayout } from "@/hooks/layout";
import ApplicationLayout from "@/components/layout";
import ErrorPage from "../errorPage";
import { useGetModuleViewQuery } from "@/store/mvc";
import { useLogger } from "@/utils/loggerService";
import { Slot } from "@/utils/types/layout";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
/**
 * Element d'affichage d'un module
 * @returns
 */
export default function ModulePage() {
    var _a;
    var logger = useLogger().logger;
    var _b = useParams(), queryModuleName = _b.module, queryAction = _b.action, queryRecord = _b.record;
    var layout = useLayout();
    var t = useTranslation(["common"]).t;
    var moduleName = queryModuleName || "Home";
    var action = queryAction || "index";
    var record = queryRecord || "";
    // 👉 state pour redirection douce
    var _c = useState(false), redirectingHome = _c[0], setRedirectingHome = _c[1];
    var navigate = useNavigate();
    var _d = useGetModuleViewQuery({
        moduleName: moduleName,
        action: action,
        record: record,
    }, { refetchOnMountOrArgChange: true }), moduleViewResult = _d.data, moduleViewError = _d.error, isLoading = _d.isLoading, isFetching = _d.isFetching, isError = _d.isError, error = _d.error;
    useEffect(function () {
        var _a;
        logger.debug("[Module Display] - Mise à jour de la vue principale", moduleViewResult);
        var widget = (_a = moduleViewResult === null || moduleViewResult === void 0 ? void 0 : moduleViewResult.data) === null || _a === void 0 ? void 0 : _a.widget;
        if (widget) {
            layout.setWidget(__assign(__assign({}, widget), { payload: __assign({}, widget === null || widget === void 0 ? void 0 : widget.payload) }));
        }
    }, [moduleViewResult]);
    useEffect(function () {
        // Nettoyage des composants pendant le chargement
        if (isLoading) {
            layout.clearWidgets({ slot: Slot.MAIN });
        }
    }, [isLoading]);
    if (isError) {
        logger.error("[Module Display] - Erreur de chargemet de la vue.", moduleViewError);
        var err = moduleViewError;
        console.log(err);
        var status_1 = (err === null || err === void 0 ? void 0 : err.status) || 500;
        var message = ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) || "Module not found";
        var originalStatus = err === null || err === void 0 ? void 0 : err.originalStatus;
        if (status_1 === "PARSING_ERROR" || originalStatus === 200) {
            return _jsx(ErrorPage, { code: "403" });
        }
        //layout.clearWidgets({ slot: Slot.MAIN });
        return _jsx(ErrorPage, { code: status_1, msg: message });
    }
    return _jsx(ApplicationLayout, {});
}
